import Vue from 'vue';
import VueRouter from 'vue-router';


import eMobiVehicle from './pages/eMobiVehicle.vue';
import eMobiCenter from './pages/eMobiCenter.vue';

import Nara2023Mobile from './pages/Nara2023Mobile.vue';
import Nara2023Vehicle from './pages/Nara2023Vehicle.vue';

import mopiVehicle from './pages/mopiVehicle.vue';
import mopiCenter from './pages/mopiCenter.vue';

import ota from './pages/ota.vue';


Vue.use(VueRouter);

export default new VueRouter({
    routes: [


// ---------------------------------------------------
// ----------           2022 12 eMobi        ---------
// ---------------------------------------------------
        {
            path: '/eMobiCenter',
            component: eMobiCenter,
            meta: {
                keepAlive: true
            }
        },

        {
            path: '/eMobiVehicle',
            component: eMobiVehicle,
            meta: {
                keepAlive: true
            }
        },





// ---------------------------------------------------------------------------------
// ----------           2023 3/3-13 Nara Order Remote Control              ---------
// ---------------------------------------------------------------------------------
        {
            path: '/Nara2023Mobile',
            component: Nara2023Mobile,
            meta: {
                keepAlive: true
            }
        },

        {
            path: '/Nara2023Vehicle',
            component: Nara2023Vehicle,
            meta: {
                keepAlive: true
            }
        },



// ---------------------------------------------------
// ----------           2023 6 Mopi          ---------
// ---------------------------------------------------
        {
            path: '/mopiCenter',
            component: mopiCenter,
            meta: {
                keepAlive: true
            }
        },

        {
            path: '/mopiVehicle',
            component: mopiVehicle,
            meta: {
                keepAlive: true
            }
        },

        {
            path: '/',
            component: ota,
            meta: {
                keepAlive: true
            }
        },

    ]
});